<template>
    <button class="hotspot white" type="button" :id="area.handle" :title="area.name"  :style="styles"><span class="plus">+</span></button>
</template>
<script>
import $ from 'jquery';
window.$ = require('jquery');
    export default {
        props : ["area"],
        computed : {
            styles() {
                return 'top:'+this.area.position.top+';left:'+this.area.position.left+';';
            }
        },
        mounted() {
            if(this.area.hotspot_text) {
                $(this.$el).before(`<h3 style="position:absolute;transform: translateY(-250%);${this.styles}">${this.area.hotspot_text}</h3>`);
            }
        }
    }
</script>